export default __webpack_public_path__ + "static/media/clouds-right-mobile.e3db38a1.png";